import React from 'react';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';

const AdditionalPDFSelect = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div>
      <h4>{t('common.additionalPDF')}</h4>
      <Radio.Group
        onChange={onChange}
        value={value}
        style={{ display: 'flex', flexDirection: 'column' }}
        className="vertical-radio-group"
      >
        <Radio value={'downloadPdf'}>
          {t("buildingSetupChanges.downloadPdf")}
        </Radio>

        <Radio value={'downloadCleaningPartnerPdf'}>
          {t("buildingSetupChanges.downloadCleaningPartnerPdf")}
        </Radio>
      </Radio.Group>
    </div>
  );
};

export default AdditionalPDFSelect;
